module.exports = {
  businessNumber: 'Business Number',
  businessType: 'Business Type',
  mblNo: 'MBL No',
  customer: 'Customer',
  carrier: 'Carrier',
  vessel: 'Vessel',
  shippingCompanyContractNo: 'Shipping Company ContractNo',
  voyageFlight: 'Voyage/Flight',
  portOfLoading: 'Port Of Loading',
  SeaPortOfLoading: 'Seaport Of Loading',
  AirportOfLoading: 'Airport Of Loading',
  portOfDestination: 'Port Of Destination',
  dischargingPortCode: 'Port Of Discharging',
  dateOfDeparture: 'ETD',
  businessDate: 'Business Date',
  businessReferenceNumber: 'Business Reference Number',
  bookingAgent: 'Booking Agent',
  dateOfCreation: 'Date Of Creation',
  dateOfProof: 'Date Of Proof',
  operation: 'Operation',
  sales: 'Sales',
  salesDepartment: 'Sales Department',
  CustomerService: 'Customer Service',
  Documents: 'Documents',
  accrued: 'Accrued',
  status: 'Status',
  actualChargedWeight: 'Actual Charged Weight',
  profit: 'Profit',
  totalIncome: 'Total Income',
  totalCost: 'Total Cost',
  closingAccountStatus: 'closingAccount Status',
  hasReceivable: 'hasReceivable',
  profitExcludingTax: 'Profit(Excl Tax)',
  totalIncomeExcludingTax: 'Total Income(Excl Tax)',
  totalCostExcludingTax: 'Total Cost(Excl Tax)',
  profitClosingAccount: 'Profit(No Accounting)',
  totalIncomeClosingAccount: 'Total Income(No Accounting)',
  totalCostClosingAccount: 'Total Cost(No Accounting)',
  hasReceivableTotal: 'hasReceivableTotal',
  profitCommission: 'Profit(Commission)',
  totalIncomeCommission: 'Total Income(Commission)',
  totalCostCommission: 'Total Cost(Commission)',
  provisionedStatus: 'provisioned Status',
  refundCommission: 'refund Commission',
  closingAccountRevenue: 'ClosingAccount Revenue',
  closingAccountCost: 'ClosingAccount Cost',
  invoiceCost: 'Invoice Cost',
  payablesWriteOfStatus: 'Payables Write Of Status',
  receivablesWriteOfStatus: 'Receivables Write Of Status',
  payablesConfirmOfStatus: 'Payables Confirm Of Status',
  receivablesConfirmOfStatus: 'Receivables Confirm Of Status',
  accrualDate: 'Accrual Date',
  creator: 'Creator',
  receivables: 'Receivables',
  payables: 'Payables',
  englishDescriptionOfGoods: 'Commodity description(EN)',
  chineseDescriptionOfGoods: 'Commodity description(CN)',
  consignationCompany: 'Consignation Company',
  settlementCompany: 'Settlement Company',
  destinationAgent: 'Destination Agent',
  nominatedAgent: 'Nominated Agent',
  destinationAgentShortName: 'Destination agent short name',
  nominatedAgentShortName: 'Nominated agent short name',
  containerNo: 'Container No',
  amountRange: 'Amount Range',
  profitRange: 'Profit Range',
  localAmountRange: 'Local Amount Range',
  SubmissionDateTime: 'Submission Time ',
  AuditDateTime: 'Audit Time',
  feeStatus: 'Fee Status',
  redChargesOrNot: 'Red Charges Or Not',
  seaportOfDischarge: 'Port of Discharge(seaport)',
  airportOfDischarge: 'Port of Discharge(airport)',
  airportOfDestination: 'Port of Destination(airport)',
  operationDepartment: 'Operation Department',
  invoiceDate: 'Invoice Date',
  invoiceDateAR: 'Receivables Invoice Date',
  financialaDate: 'Financial Date',
  solicitationType: 'Solicitation Type',
  warehouseNo: 'Warehouse No',
  itemNo: 'Project number',
  receivablesInvoicingStatus: 'Invoicing Status',
  receivablesInvoicingStatusAr: 'Receivables Invoicing Status',
  businessStatus: 'Business Status',
  customJobType: 'Custom Job Type',
  separateNumber: 'Separate Number',
  containerDescription: 'Container Description',
  designationAgent: 'Nominated Agent',
  masterBLFreightTerm: 'MBL Freight Terms',
  HBLFreightClause: 'HBL Freight Terms',
  IncoTerm: 'IncoTerm',
  FLCLType: 'Deliv. Mode',
  SeaExportFLCLType: 'SeaExport Deliv. Mode',
  SeaImportFLCLType: 'SeaImport Deliv. Mode',
  OperateType: 'Operate Type',
  AirExportOperateType: 'AirExport Operate Type',
  AirImportOperateType: 'AirImport Operate Type',
  UserDefinedField1: 'User Defined Field 1',
  UserDefinedField2: 'User Defined Field 2',
  UserDefinedField3: 'User Defined Field 3',
  ManageAuditStatus: 'Profit review status',
  paymentRequestNumber: 'Payment Request Number',
  placeOfDelivery: 'Place of Delivery',
  changeState: 'Change State',
  grossProfitRate: 'Gross Profit Rate',
  railwayTransportLine: 'Railway TransportLine',
  route: 'Route',
  exportLoadingPlan: 'Export loading plan',
  exportSalesReport: 'Export sales report',
  moreOperations: 'More operations',
  routeOperation: 'Route operation',
  completeBooking: 'Complete Booking',
  warehousing: 'Warehousing',
  mountingBoard: 'mounting board',
  pullGood: 'Pull goods',
  applicationForFlightAdjustment: 'Application for flight adjustment',
  allocateFlights: 'Allocate flights',
  confirmCabinAllocation: 'Confirm cabin allocation',
  cancelConfirmationOfCabinAllocation: 'Cancel confirmation of cabin allocation',
  copyIncomingData: 'Copy incoming data',
  otherRemarks: 'Other remarks',
  otherExpenses: 'Other expenses',
  delivery: 'delivery',
  deliveryAgent: 'Delivery agent',
  uploadBoardPhotos: 'Upload board photos',
  subLabel: 'Sub label',
  prefabricatedMasterOrder: 'Prefabricated master order',
  prefabricationOrderSplitting: 'Prefabrication order splitting',
  printMasterOrder: 'Print master order',
  printSplit: 'Print split',
  track: 'track',
  takeOff: 'take off',
  arrival: 'Arrival',
  Discharge: 'Discharge',
  billOfLadingInquiry: 'Bill of lading inquiry',
  expandAll: 'Expand all',
  putItAllAway: 'Put it all away',
  noBusinessFlight: 'No business flight',
  heavy: 'heavy',
  takeOff2: 'Take off',
  arrivedAtPort: 'Arrived at port',
  size: 'size',
  cabinAllocationStatus: 'Cabin allocation status',
  installationInstructions: 'Installation instructions',
  photograph: 'photograph',
  guanFeng: 'Guan Feng',
  singleCopy: 'Single copy',
  flightInformationEmpty: 'Flight information is empty.',
  lockFlight: 'Lock flight',
  unlockFlight: 'Unlock flight',
  cabinAllocationStatusConfirmed: 'Is the cabin allocation status of ticket business set to confirmed?',
  confirmationSucceeded: 'Confirmation succeeded!',
  confirmThis: 'Confirm this',
  cabinAllocationStatusUnconfirmed: 'Is the cabin allocation status of ticket business set to unconfirmed?',
  hair: 'hair',
  selectBookedOrder: 'Please select the list to be booked!',
  preprint: 'Preprint',
  undoPrinting: 'Undo printing',
  temporaryStorage: 'Temporary storage',
  bookingNumber: 'Booking number',
  bookingTime: 'Booking time',
  descriptionOfBookingResults: 'Description of booking results',
  declared: 'Declared',
  enterDeliveryAgent: 'Please enter delivery agent.',
  whetherTakePhotos: 'Whether to take photos',
  siteRemarks: 'Site remarks',
  otherInstructions: 'Other instructions',
  enterBillOfLadingNumber: 'Please enter the bill of lading number',
  takeoffTime: 'Takeoff time',
  deliveryTime: 'Delivery time',
  trackingFlight: 'Tracking flight',
  trackingArrival: 'Tracking arrival',
  trackingDelivery: 'Tracking delivery',
  enterDepartureTime: 'Please enter the departure time',
  enterArrivalTime: 'Please enter the arrival time',
  enterDeliveryTime: 'Please enter the delivery time',
  receivingOutsideWarehouse: 'Receiving (outside warehouse)',
  warehousingTime: 'Warehousing time:',
  damagedAndDamp: 'Damaged and damp',
  photo: 'Photo',
  selectPhotos: 'Select photos',
  deletePhotos: 'Delete photos',
  selectWarehousingDate: 'Please select the warehousing date!',
  enterSubLabel: 'Enter sub label',
  receiptNo: 'Receipt No',
  pleaseEnterSubLabel: 'Please enter a sub label',
  uploading: 'Uploading',
  oneFileVolumn2MB: 'The volume of one file exceeds 2MB and cannot be uploaded',
  failedDeleteFile: 'Failed to delete file!',
  uploadSucceeded: 'Upload succeeded',
  uploadFailed: 'Upload failed',
  uploadComplete: 'Upload complete',
  notExceed6Lines: 'The maximum can not exceed 6 lines!',
  line: 'Line',
  airTransportArea: 'Air Transport Area',
  operationalResponsibilities: 'Operational Responsibilities',
  assignmentOfResponsibilities: 'Assignment Of Responsibilities',
  roleList: 'Role List',
  assignedResponsibilities: 'Assigned Responsibilities',
  listOfResponsibilities: 'List Of Responsibilities',
  NoVoucherGeneratedReceivable: 'No voucher generated receivable',
  NoVoucherGeneratedPayable: 'No voucher generated payable',
  VoucherGeneratedReceivable: 'voucher generated receivable',
  VoucherGeneratedPayable: 'voucher generated payable',
  TenTicketsAtTheSameTime: 'You can view up to 10 tickets at the same time. Please re select.',
  DataChangedToReopen: 'The data has been changed. Please open it again and edit it.',
  JobOpenedAndCannotDelete: 'This ticket business has opened a new tab and cannot be deleted!',
  AreWantToDeleteBusiness: 'Are you sure you want to delete this ticket business?',
  DoToDeleteTheTicket: 'Do you want to delete the ticket?',
  AreToDeleteTheBusiness: 'Are you sure you want to delete the currently selected business?',
  AreToConvertTheItem: 'Are you sure you want to convert the currently selected item?',
  ConversionSucceeded: 'Conversion succeeded',
  OperationDepartmentCannotBeEmpty: 'Operation department cannot be empty!',
  OrangeWorkingDaysFromETA: 'Orange: within seven working days from ETA',
  RedWorkingDaysFromETA: 'Red: within three working days from ETA',
  BatchOfWholeSplicingType: 'Batch modification of whole splicing type:',
  UploadedOnlyBeInFormat: 'Uploaded files can only be in CSV format!',
  ThatSOk: 'that \'s ok',
  NotInPositiveOperation: 'Not in positive operation',
  AreTicketsSubmitted: 'Are tickets submitted?',
  IsTheTicketPreSubmitted: 'Is the ticket pre submitted?',
  AreWantToWithdrawTicket: 'Are you sure you want to withdraw this ticket?',
  BillOfLadingInformationTracking: 'Bill of lading information tracking',
  PleaseMaintainTheJumpAddress: 'Please maintain the jump address!',
  CannotBeEmpty: 'Cannot be empty',
  AreWantToRemoveTicket: 'Are you sure you want to remove this ticket?',
  NoBusinessSelected: 'No business selected',
  IfForTheGoodsSame: 'If the overseas agent uses the promissory note for the goods here, the price is the same',
  EspeciallyPeersThatUBISpace: 'Especially the shipping company or peers that UBI went to book space',
  UnitKg: 'Unit: kg',
  UnitCubicMeter: 'Unit: cubic meter',
  UnitTon: 'Unit: ton',
  DoorNotBeenSavedPrinted: 'Door point information that has not been saved cannot be printed!',
  CaseNo: 'Case No',
  AllTheAssociationDoContinue: 'All data will be removed from the association. Do you want to continue',
  DetailsSeaborneExportGoodsXls: 'Details of seaborne export goods xls',
  FindTheTrailerLocationNow: 'Find the trailer location now',
  EstimatedLoadingDate: 'Estimated loading date',
  SelectDateAndTime: 'Select date and time',
  PrimaryDocNoAlreadyExists: 'Primary doc No. already exists',
  PleaseEnterTheFlightNumber: 'Please enter the flight number',
  PleaseEnterETD: 'Please enter ETD',
  PleaseEnterAnAction: 'Please enter an action',
  PleaseEnterTheRoute: 'Please enter the route',
  AreWantToAllocateFlight: 'Are you sure you want to allocate this [{0}] flight?',
  DeploymentSucceeded: 'Deployment succeeded!',
  SuccessfullyPicturesAreYouSave: 'Successfully uploaded: {0} pictures, failed: {1} pictures, are you sure you want to save?',
  TheSelectedRecordMustSame: 'The ETD of the selected record must be the same!',
  TheSelectedRecordsMustSame: 'The airlines of the selected records must be the same!',
  PleaseWithTheSameMode: 'Please select a business with the same operation mode',
  SiruiPleaseContactTheTroubleshooting: 'Sirui entrustment order push failed, please contact the staff for troubleshooting:',
  BusinessTodayIsNotCustoms: 'Business with sailing date greater than today is not allowed to return customs',
  G7DataPush: 'G7 data push',
  DropDown: 'drop-down ',
  TheBeenAddedToOrder: 'The split order has been added to the main order!',
  NotBoundYet: 'Not bound yet!',
  TheCostSharingAndSeparated: 'The current small ticket has cost sharing and cannot be separated!',
  AreUnbindTheMasterOrder: 'Are you sure you want to unbind the master ticket or master order?',
  PleaseEnterOperatorInformation: 'Please enter operator information!',
  TheIsIllegalPleaseEnter: 'The primary order number is illegal, please re-enter!',
  PleaseTheDesignatedShippingAgent: 'Please enter the designated shipping agent!',
  TheseWillBeSetJoin: 'These fields are different from the main ticket. If you want to join the main ticket, it will be set to be the same as the main ticket. Are you sure you want to join?',
  TheNotExceed6Lines: 'The maximum can not exceed 6 lines!',
  TheNotExceed7Lines: 'The maximum can not exceed 7 lines!',
  ThereMasterTicketThisPerformed: 'There are charges in the master ticket. This operation cannot be performed!',
  TheTicketIfYouSwitch: 'The small ticket has been bound to the main ticket and there is only one small ticket under the main ticket. If you want to switch the operation mode, the main ticket will be deleted! Are you sure you want to switch?',
  TheTheBindingRelationshipSwitch: 'The small ticket has been bound to the main ticket. If you switch the operation mode, the binding relationship with the main ticket will be released! Are you sure you want to switch?',
  SwitchAMasterTicketSwitch: 'Switch to the mode of one master and multiple points, and the system will automatically create a master ticket and bind it with the current ticket! Are you sure you want to switch?',
  DateExceededCreditControl: 'Partner account period has exceeded!',
  AmountExceededCreditControl: 'Partner quota has exceeded!',
  DateAndAmountExceededCreditControl: 'Partner quota account period has exceeded!',
  ThisHasExceededCreditControl: 'This partner has exceeded credit control',
  ItAEntrustingUnitAgent: 'It can not be used as a entrusting unit or designated freight agent',
  ThisHasBeenAutomaticallyCleared: 'This column has been automatically cleared',
  JoinTheTicketSuccessfully: 'Join the ticket successfully!',
  ThereSplitTicketTheTicket: 'There is only one split ticket in the current master ticket. If you want to remove the split ticket, the master ticket will be automatically removed. Are you sure you want to remove the split ticket?',
  TheTicketHasBeenRemoved: 'The master ticket has been removed!',
  AreRemoveThisSubTicket: 'Are you sure you want to remove this sub ticket from the main ticket',
  AttachmentDescription: 'Attachment description',
  AirlineCachePleaseResetAgain: 'Airline information is not found in the cache, please reset the cache and try again',
  ResettingTheModifiedContentContinue: 'Resetting the initial value will overwrite the modified content. Do you want to continue?',
  PleaseEnterTheSplitNumber: 'Please enter the split number',
  AlreadyExists: 'Already exists!',
  DetailsAirExportGoodsXls: 'Details of air export goods xls',
  PleaseSelectWarehousingData: 'Please select warehousing data!',
  AreToDeleteThisData: 'Are you sure to delete this warehousing data?',
  TheRateMAndAdjusted: 'The total value is less than the maintained freight rate M, and the freight rate related information cannot be adjusted!',
  AirlineInformation: 'Airline information',
  PleaseSelectAFee: 'Please select a fee',
  SelectMainOrder: 'Select main order',
  ManualInput: 'Manual input:',
  TheOrderNumberIsIllegal: 'The primary order number is illegal!',
  WarehousingInstructions: 'Warehousing instructions',
  OtherInstructions: 'Other instructions:',
  GoodsIntoThisWarehouse: 'Goods into this warehouse',
  NeedPhotos: 'Need photos',
  AttachedDocuments: 'Attached documents',
  Generate: 'generate',
  Save: 'Save?',
  PleaseTheEstimatedWarehousingTime: 'Please enter the estimated warehousing time!',
  AirlineCompany: 'airline company:',
  Flight: 'Flight:',
  FieldOperation: 'Field operation:',
  SendFieldOperation: 'Send field operation',
  EntrustedWeight: 'Entrusted weight',
  NumberOfBookingPieces: 'Number of booking pieces',
  BookingWeight: 'Booking weight',
  BookingVolume: 'Booking volume',
  PleaseFillInTheFlight: 'Please fill in the flight!',
  PromissoryHaveBecomeOfficialBusiness: 'Promissory notes have become official business',
  ThisApprovalStatusAndEdited: 'This document has entered financial approval status and cannot be edited.',
  AreToConvertTheItem2: 'Are you sure you want to convert the currently selected item?',
  TheDoesNotComplyRules: 'The primary order number does not comply with the rules!',
  DoubleOfLadingHeaderUp: 'Double click the bill of lading header to pop up',
  SmallNumberOfVotes: 'Small number of votes',
  NumberOfPrimaryVotes: 'Number of primary votes',
  ThePleaseMaintainTheFirst: 'The primary doc No. is blank. Please maintain the primary doc No. first',
  TheTheNewlySelectedContinue: 'The flight number, airline, departure date, arrival date, delivery method and freight terms of the main bill of lading of the newly selected small ticket are inconsistent with those of the main ticket. The system will modify the small ticket. Continue?',
  ClickSelectTheGoodsCode: 'Click the space to select the goods category code',
  AreSureVoidThisTicket: 'Are you sure you want to void this ticket?',
  AllChargesBeDeleted: 'All charges will be deleted!',
  SellingPriceCalculationCompleted: 'Selling price calculation completed',
  OperationOfTicketCannotEdited: 'You are not the operation of this ticket and cannot be edited.',
  ActualNotifierCannotBeBlank: 'Actual notifier cannot be blank',
  SpecifiedFreightAgentCannotEmpty: 'The specified freight agent cannot be empty',
  ArrivalDateCannotBlank: 'Arrival date cannot be blank',
  OperationDepartmentCannotBlank: 'Operation department cannot be blank',
  ExpectedArrivalDateCannotBlank: 'Expected arrival date cannot be blank',
  PleaseReselect: 'Please reselect',
  EstimatedProfitNotCompanyRegulations: 'The estimated profit of promissory note business does not meet the company\'s regulations {0}. Are you sure to save it?',
  ReceivableExpensesMustBeEntered: 'Receivable expenses must be entered.',
  PayableExpensesMustBeEntered: 'Payable expenses must be entered.',
  BlockedCannotUsedContactCustomerManagement: '[{0}] It has been blocked and cannot be used. Please contact the customer management of our company',
  // REQ-0005: blocked partner (with inactive reason)
  CompanyBlockedCannotUsedWithReason: '[{0}] has been blocked. Inactive reason: [{1}].',
  CompanyBlockedCannotUsed: '[{0}] has been blocked.',
  exportOption: 'Export Option',
  exportDescription: 'Export description',
  dataNotMerged: 'Data not merged',
  noMoreReminders: 'No more reminders',
  UsCustomsClearance: 'US customs clearance',
  CustomerInformation: 'Customer information',
  DeclarationMaterials: 'Declaration materials',
  TopSecretInformation: 'Top secret information',
  DeletionIsUnrecoverable: 'The deletion is unrecoverable. Are you sure you want to delete the data?',
  PleaseEnterOnLine: 'Please enter {1} of line {0}',
  CustomerName: 'Customer name',
  CustomsClearanceProductName: 'Customs clearance product name',
  NumberOfPackages: 'Number of packages',
  NumberOfGoods: 'Number of goods',
  CustomsClearanceUnit: 'Customs clearance unit',
  Export7501: 'Export 7501',
  ExportInvoicePackingList: 'Export invoice packing list',
  GenerateReceivableExpense: 'Generate receivable expense',
  GeneratePayableExpenses: 'Generate payable expenses',
  CopyAsCustomerData: 'Copy as customer data',
  CopyAsDeclarationData: 'Copy as declaration data',
  CopyAsTopSecretInformation: 'Copy as top secret information',
  PdfType: 'Pdf type',
  MergeProductNamesWhenFiles: 'Merge the same product names when generating files',
  ShowTax: 'Show tax',
  ShowChinaSurtax: 'Show China surtax',
  ShowMargin: 'Show margin',
  MarginAmount: 'Margin amount',
  TotalNetWeight: 'Total net weight',
  TotalValue: 'Total value',
  TotalTariff: 'Total tariff',
  TotalOtherExpenses: 'Total other expenses',
  UnitWeight: 'Unit weight',
  ItemPricing: 'item pricing ',
  TotalPriceOfGoods: 'Total price of goods',
  ChinaAdditionalTaxRate: 'China additional tax rate',
  ChinasSurtaxTariff: 'China\'s surtax tariff',
  ChinaSurtaxClause: 'China surtax clause',
  AccountsReceivableGeneratedSuccessfully: 'Accounts receivable generated successfully.',
  PayableExpensesGeneratedSuccessfully: 'Payable expenses generated successfully.',
  ThePleaseConfirmWhetherData: 'The emptying operation cannot be resumed. Please confirm whether to empty the data?',
  TheSureYouWantData: 'The deletion operation cannot be recovered. Are you sure you want to delete this row of data?',
  BusinessDateChangedUpdateExchangeRate: 'The business date has changed, please pay attention to updating the expense exchange rate',
  CustomsClearance: 'Customs clearance',
  QuantityIsInconsistentOfEqSizeType: '[{eqSize}{eqType}] the box quantity is inconsistent with the packing information quantity',
  QuantityIsInconsistentOfCodeType: '【{containerCode}{containerType}】the box quantity is inconsistent with the packing information quantity',
  syncChargesToExportJobMessage: 'Common steps: {total} information, {successCount} success, {failCount} failure',
  syncChargesToExportJobFailMessage: `<span>Synchronization <span style="color:blur">{total}</span> charges, succeeded <span style="color:green">{successCount}</span>, failed <span style="color:red">{failCount}</span>
  <b>The reasons are as follows</b><br/>`,
  ImportReceivablePpayableObjectNotEqualCustomer: 'Charge {no}: Import receivable/payable expense settlement object != exporter (entrusting company)',
  BillGenerated: 'Charge {no}: bill generated',
  InvoiceIssued: 'Charge {no}: invoice issued',
  AccountWrittenOff: 'Charge {no}: account written off',
  PaymentApplication: 'Charge {no}: payment application',
  ExpenseConfirmationYes: 'Charge {no}: expense confirmation - yes',
  ExpenseStatusSubmitted: 'Charge {no}: expense status - submitted',
  CollectionAdvancePayment: 'Charge {no}: collection and advance payment',
  ExpensesGeneratedByVarianceProcessing: 'Charge {no}: expenses generated by variance processing',
  Shared: 'Charge {no}: shared',
  NotOperatingCannotSynchronized: 'The order with non positive operation cannot be synchronized',
  ImportHasSynchronizedDispatchingInformation: '<b style="font-size:16px">The import order has synchronized the dispatching information</b><br><span style="font-size:16px">Do you want to continue?</span>',
  MatchingConditionsForPushSOPReceiver: 'Matching conditions for push SOP receiver',
  GenerateXChargeSyncRecords: 'Generate {num} charge synchronization records',
  Density: 'Density',
  CommissionedDensity: 'Delegated density',
  ActualDensity: 'Actual density',
  EstimatedReviewer: 'Estimated Reviewer',
  DateOfPreReview: 'Date of pre-review',
  EnteredXNotMatchAirlineCode: 'The entered flight code {0} does not match the airline Code',
  EnteredXNotMatchAirlinePrefix: 'The entered mbl Top 3 {0} does not match the airline MAWB Prefix',
  HasPackingFeeEnterWarehouse: 'There is a packing fee, please enter the warehouse information!',
  SuccessSyncInfo: 'Successfully synchronized information',
  Search: 'search',
  Clear: 'clear',
  ShipperName: 'shipper name',
  ConsigneeName: 'consignee name',
  NotifyPartyName: 'notify party name',
  AfterToBeRevokedSynchronize: 'After confirming the synchronization, it is not allowed to be revoked. Are you sure you want to synchronize?',
  PleaseADataToDelete: 'Please select a data to delete!',
  CreatePaymentRequestSelectFee: 'Create payment request - select fee',
  PleaseSelectTheBill: 'Please select the bill.',
  YouViewOrPrintOthers: 'You do not have permission to view or print files uploaded by others.',
  AgentCommissionBill: 'Agent commission bill',
  TheWithdrawnAndCannotOperated: 'The business has been withdrawn and cannot be operated.',
  PleaseSelectTheForeignBill: 'Please select the foreign bill.',
  Equivalent: 'Equivalent',
  EquivalentToRMB: 'Equivalent to RMB',
  OperationFailed: 'Operation failed',
  FrontEndErrorCallbackFailed: 'Front-end error: callback failed',
  YouToEditTheAdministrator: 'You do not have the corresponding permission to edit the data, please contact the administrator',
  UploadingPleaseWait: 'Uploading, please wait...',
  AssociateBusinessSOPNode: 'Associate business SOP node',
  CustomsDuty: 'Customs duty',
  AddAmendmentFee: 'Add amendment fee',
  AddNewBusiness: 'Add new business',
  Add: 'Add',
  Maintain: 'Maintain',
  Modify: 'Modify',
  PleaseEnterTheBusinessNumber: 'Please enter the business number!',
  ReceiptSuccessful: 'Receipt successful',
  WaitingForReceipt: 'Waiting for receipt',
  SaveSuccessfully: 'Save successfully',
  SendEmail: 'Send email',
  SystemEmail: 'System email',
  CompanyEmail: 'Company email',
  PersonalEmail: 'Personal email',
  Submitted: 'Submitted',
  DataSource: 'Data source',
  SystemInput: 'System input',
  PortAreaData: 'Port area data',
  UpdateToPortAreaData: 'Update to port area data',
  NewExportClearancePolicy: 'New export clearance policy',
  YangshanAreaNovember152021: 'Yangshan Customs Area: November 15, 2021',
  WaigaoqiaoAreaNovember222021: 'Waigaoqiao Customs Area: November 22, 2021',
  GarbageManifest: 'Garbage manifest',
  N1OnceTheManifestManifest: '1. Garbage manifest is strictly prohibited by the customs! According to customs regulations, each pre-allocated manifest must correspond to a shipment of actual shipped goods. Once the manifest is sent and your goods are not shipped (missed the ship, shipping plan changed, etc.), the manifest will be regarded as a garbage manifest!',
  N2ManifestMustBeDeletion: '2. Example of garbage manifest: After the ship is re-allocated, the original pre-allocated manifest must be deleted, and the new pre-allocated manifest can be sent only after deletion!',
  N3YuanOnTheManifest: '3. Consequences of not deleting garbage manifest: Not only will it affect shipping, but the customs can also impose a fine of up to 50,000 yuan on the freight forwarder and cancel their customs declaration qualifications! If a garbage manifest appears, please contact customer service in time to help delete the garbage manifest!',
  BusinessUUIDCannotBeEmpty: 'Business UUID cannot be empty!',
  BillUUIDCannotBeEmpty: 'Bill UUID cannot be empty!',
  FileInformation: 'File information',
  BillingInformation: 'billing information',
  DomesticWarehouse: 'domestic warehouse',
  ForeignWarehouse: 'foreign warehouse',
  ExpectedTimeAtAmazonWarehouse: 'expected arrival time at Amazon warehouse',
  ReferenceBoxNumber: 'reference box number',
  TotalDoesNotEqualCost: 'Total cost allocation of small tickets does not equal to the original cost!',
  NameCannotBeEmpty: 'Name cannot be empty!',
  SOPOperationStatus: 'SOP operation status',
  AddSpecialFees: 'Add special fees',
  TrailerTrackingUsageNotice: 'Trailer tracking usage notice',
  N1SituationIncludingButDepartments: '1. In accordance with relevant national laws and regulations, the system is obliged to record the user\'s query situation, including but not limited to (plate number, operator, query time), as to provide necessary evidence for relevant departments',
  N2ConsentBeforeQueryingCommunication: '2. In accordance with national laws and regulations, obtain the vehicle owner\'s consent before querying vehicle location information, and avoid infringement by obtaining authorization through communication.',
  N3TheOwnersConsentConsequences: '3. If users query vehicle information without the owner\'s consent, they shall bear the legal consequences.',
  N4ItToIrrelevantUser: '4. If authorization is granted, use the information within the scope and avoid disclosing it to irrelevant parties. Legal liability resulting from this shall be borne by the user.',
  N5SystemCannotGuaranteeResponsibility: '5. Due to uncontrollable factors (e.g. GPS device failure), the system cannot guarantee accurate query results and does not bear any responsibility.',
  N6BeAwareOfHome: '6. As tow truck tracking is provided through third-party cooperation, during service usage, users allow third parties to be aware of your presence and may contact you. This is not due to information disclosure by CargoWare/Wo Lian Home.',
  DoNotRemindMeAgain: 'Do not remind me again',
  IUnderstoodAndConfirmContinuing: 'I have understood, and confirm continuing',
  ImportModeTip: 'Import type is modified, the system matches the data consistent with the port area according to the customs declaration number, box number, seal number, container type, and container type.\nImport type is maintained, the data you entered is not matched with the port area data, which is the original data you entered.',
  NewExportClearancePolicyTip: 'Shanghai Customs No. 172 order switches the release conditions, using the ""Loading Manifest"" receipt to transmit the sea release information to the terminal. Please pay attention to the loading manifest status after the customer completes the customs declaration, and contact customer service to confirm any abnormal situations. During this period, the residual manifest not being deleted in time in LCL, untimely cargo release, irregular additions after release, unsuccessful modification of manifest data, mixed loading, and the use of the same bill of lading number within two years will affect the shipment. Secondly, after receiving a normal receipt of the loading manifest, if there is any need to modify, delete or add a pre-allocated manifest, the shipping agent must be contacted to delete the loading manifest before continuing the operation.',
  Upload0UploadFailed0: 'Upload successful: {0}, upload failed: {1}.',
  CustomerBranchScopeNot: 'The affiliation of the entrusted unit to the branch is incorrect. Please choose again to maintain consistency.',
  BatchInitiateCollaboration: 'Batch initiate collaboration',
  OrderCenterBranchNotAvailable: '{0} is an order receiving branch, but the order receiving branch configuration has not been enabled',
  BatchCollaboration: 'Batch collaboration',
  SuccessCooperateX: 'Successfully collaborated on {0} transactions',
  SuccessCooperateXFailY: 'Successfully collaborated on {0} transactions, failed on {1} transactions. Reason for failure:',
  BusinessIsMaster: 'Business {0} is the main ticket',
  NotBranchCollaborationManageme: 'Business {0} is not a receiving branch, nor does it have the authority to operate company collaboration management',
  OpOfficeNotCooperateBranch: 'Business {0} operating company cannot be a collaborative branch',
  ExistCollaborationBranchRecord: 'Business {0} already has a collaboration record accepting branch {1}',
  EntrustedRecipient: 'Entrusted recipient',
  NoteConsigneeCustomerExportImport: 'Note: When the export "consignee" corresponds to the import "commissioning unit", please ensure that this partner has a "customer" role!!',
  SetAsDefaultExportInfo: 'Set this content as default export information',
  RecipientNotExist: 'The current recipient does not exist',
  ConsigneeCustomerNotExist: 'The current recipient does not have the role of "customer" and cannot be used as a commissioning unit. Please go to the partner module to maintain information and try again',
  CurrencyChangeCheckDiff: 'The Currency has been adjusted to {0}. Please note the decimal places for currencies such as【Prepaid】,【Collect】, and【Other Charge】.',
  InvalidBillCannotConfirm: 'The bill with invalid status cannot be confirmed. Please confirm',
  Reviewed: 'Reviewed',
  ApplicationPayInitiated: 'Application for payment has been initiated',
  NotPrintedState: 'Not in a printed state',
  StatementGenerated: 'Statement generated',
  NotUnapproved: 'Not unapproved',
  BillCannotVoid: '{0} Bill {1} cannot be invalidated, please confirm',
  SwitchHQNotView: 'You have switched to HQ branch and do not have permission to view the details page. You need to return to the list page to check again',
  JumpListPage: 'Jump to List Page',
  WhenDepartmentBranchNewSelection: 'When the department or branch of the sales/documentation/customer service personnel in the business does not match the original document, a new selection is required!',
  OneClickQuery: 'One click query',
  PreSubimtCheckTip: 'Note: Modifications are not allowed after pre submission of business. After all orders have been submitted, you can use the "one click query" button below to query failed orders.',
  SubimtCheckTip: 'Note: After submitting the business, modifications are not allowed. After all orders are completed and submitted, you can use the "one click query" button below to query failed orders.',
  FinanceAuditCheckTip: 'Note: After business review, modifications will not be allowed. After all orders have been reviewed, you can use the "One Click Query" button below to query failed orders.',
  SalesMapping: 'Sales mapping:',
  SalesCargoSalesMap: 'Mapping sales of delegated business to soliciting sales of operational business',
  BusinessRemarks: 'Business remarks',
  InternalEquipmentNote: 'Internal equipment note',
  QuantityWeightCubageConfirmed: 'The hair of the piece has been confirmed',
  DataModifiedHasMergeContinueSave: 'The data was modified by [{0}] on {1} and has been merged for you. Do you want to save it?',
  SyncYongYouNotCancelReview: 'It has been pushed to UFIDA and cannot be cancelled for review',
  PrintByBusinessNumber: 'Print by business number',
  SelectNotBelongToCurBranch: 'The selected documents include transactions that do not belong to the current branch, they cannot be modified!',
  ClickFilePrivew: 'Click on the file name to preview the file',
  PackageDownload: 'Package Download',
  CCPost: 'CC post',
  CCYourself: 'CC yourself',
  SaveCcAddresNextDefault: 'Save this CC post (for the next default to bring out)',
  ForMakingBatchTransferModifications: 'For business number {0}, only the ticket information is selected without the main ticket information, making batch transfer impossible. Please select the corresponding main ticket information and make the necessary modifications.',
  TherePositionPleaseConfirmSuitable: 'There are multiple available options for the <b>{0}</b> position. Please confirm that the currently selected candidate is suitable.',
  TheWithBusinessStandardsSelection: 'The <b>{0}</b> position does not comply with business standards. Please make a new selection.',
  PositionReSelectionReminder: 'Position Re-selection Reminder',
  LastEmailSentTime: 'Last Email Sent Time',
  SendVerification: 'Send Verification',
  BusinessOfTheSelectedMatch: 'Business validation exception: The {0} of the selected business does not match.',
  FeeReceivable: 'Fee (Receivable)',
  CostsPayable: 'Costs (Payable)',
  TheThisBusinessCannotModified: 'The delivery location for this business cannot be modified.',
  TheLoadingPOLCannotEmpty: 'The port of loading (POL) cannot be empty.',
  TheForThisShipmentModified: 'The port of loading (POL) for this shipment cannot be modified.',
  TheDestinationCannotBeEmpty: 'The final destination cannot be empty.',
  TheThisServiceCannotModified: 'The final destination of this service cannot be modified.',
  TheForThisServiceChanged: 'The port of discharge (POD) for this service cannot be changed.',
  TheDischargePODCannotEmpty: 'The port of discharge (POD) cannot be empty.',
  ShippingTypeCannotBeEmpty: 'Shipping type cannot be empty',
  InvalidCargoType: 'Invalid cargo type',
  TheServiceHasBeenModified: 'The type of cargo collection for this service has been locked and cannot be modified.',
  TheForThisServiceModified: 'The type of cargo collection for this service cannot be modified.',
  TheForThisServiceModified2: 'The category of goods for this service cannot be modified.',
  TheIsNotAllowedChanges: 'The purpose port agent is not allowed to make changes.',
  ListOfHazardousMaterials: 'List of Dangerous Goods',
  DangerousGoodsInformation: 'Dangerous Goods Information',
  CustomsProcedures: 'Customs procedures',
  CarDispatchInformation: 'Car Dispatch Information',
  QuantityGrossWeightVolume: 'Quantity/Gross Weight/Volume',
  CustomFormBusinessBooking: 'Custom Form (Business Booking)',
  BusinessOperationInstruction: '[Business Operation Instruction]',
  NonEditable: 'Non-editable',
  BatchExportToImport: 'Batch export to import',
  NonSupportImportationThroughEntry: 'Non-group companies do not support importation through export re-entry.',
  BatchProcessingForTheReselect: 'Batch export-to-import operations only support batch processing for the same destination port agent services. Please reselect!!',
  TheNotMeetTheConversion: 'The port agent and operating company do not meet the conditions for export-to-import conversion!',
  TheThePortAgentExist: 'The connecting branch of the port agent does not exist.',
  NotForReExport: 'Not for re-export',
  ExportFunctionIsNotEnabled: 'Export-to-import function is not enabled',
  BatchProgressPleaseReferBelow: 'Batch export-to-import process is in progress. Please refer to the execution results below!',
  TheDestinationPortAgentEmpty: 'The connecting branch of the destination port agent cannot be empty!',
  PleaseAFeeToEdit: 'Please select a fee to edit',
  PleaseFeesYouWantDelete: 'Please select the fees you want to delete!',
  AreWantToDeleteExpense: 'Are you sure you want to delete the selected expense?',
  ThisFeeIsNotEditable: 'This fee is not editable.',
  TheNameCannotBeEmpty: 'The fee name cannot be empty.',
  BillUpTo3Currencies: 'Bill supports up to 3 currencies!'
}
